@for (section of sections(); track section.id) {
  @if (section.id === firstCompleteSectionId()) {
    <div class="completed-divider" aria-hidden="true">
      <span class="completed-divider-label">Completed sections</span>
    </div>
  }

  <section class="section" [class.section-complete]="section.isComplete">
    <button
      type="button"
      class="section-header"
      [attr.aria-expanded]="!isSectionCollapsed(section.id)"
      [dataSelector]="'cxp-crl-section-toggle'"
      (click)="toggleSection(section.id)"
    >
      <!-- A completed section reads as complete by striking its title through (styled in the scss, per Figma 11154:76565). -->
      <span class="section-title">
        <span class="section-identifier">{{ section.identifier }}.</span>
        <span class="section-name">{{ section.name }}</span>
      </span>
      <aiwyn-icon
        class="section-chevron"
        [class.section-chevron-collapsed]="isSectionCollapsed(section.id)"
        name="chevron-right"
        [height]="16"
        [width]="16"
      ></aiwyn-icon>
    </button>

    @if (!isSectionCollapsed(section.id)) {
      <div class="section-body">
        @for (item of section.openItems; track item.id) {
          <cxp-crl-item-row
            [item]="item"
            [displayNumber]="section.identifier + '.' + item.ordinal"
            [selectionMode]="selectionMode()"
            [selected]="isItemSelected(item.id)"
            [undoPending]="isUndoPending(item.id)"
            (itemSelected)="onItemSelected($event)"
            (commentsSelected)="onItemCommentsSelected($event)"
            (selectionToggled)="onItemSelectionToggled($event)"
            (notApplicableUndone)="onItemNotApplicableUndone($event)"
          />
        }

        @if (section.finishedItems.length > 0) {
          <div class="finished-area">
            <button
              type="button"
              class="finished-toggle"
              [attr.aria-expanded]="isFinishedExpanded(section.id)"
              [dataSelector]="'cxp-crl-section-finished-toggle'"
              (click)="toggleFinished(section.id)"
            >
              {{ isFinishedExpanded(section.id) ? 'Hide' : 'View' }} finished ({{ section.finishedItems.length }})
            </button>

            @if (isFinishedExpanded(section.id)) {
              @for (item of section.finishedItems; track item.id) {
                <cxp-crl-item-row
                  [item]="item"
                  [displayNumber]="section.identifier + '.' + item.ordinal"
                  [selectionMode]="selectionMode()"
                  [selected]="isItemSelected(item.id)"
                  [undoPending]="isUndoPending(item.id)"
                  (itemSelected)="onItemSelected($event)"
                  (commentsSelected)="onItemCommentsSelected($event)"
                  (selectionToggled)="onItemSelectionToggled($event)"
                  (notApplicableUndone)="onItemNotApplicableUndone($event)"
                />
              }
            }
          </div>
        }
      </div>
    }
  </section>
}
